import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FooterComponent } from './footer.component';
import { UiKitModule } from '../ui-kit';
import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, FontAwesomeModule, UiKitModule, RouterModule],
  exports: [FooterComponent],
})
export class FooterModule {}
